import React, { useEffect, useState } from 'react';
import defaultConfig from './alme-config/appConfigMain';
import App from './App';
import { isMobileDevice } from './components/AlmeUtilities/device-utils';
import { ConsoleLogger, defaultLogLevel } from './Logger';
import { hasVistaChatPropValidationError } from './IVAChatPropValidation';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
const isProdEnv = (apiHostName) => {
    return apiHostName === 'iva.synchronycredit.com';
};
const getFileURL = (apiHostName) => {
    return `https://${apiHostName}/alme/alme-api-routing.js`;
};
const hasInvalidProps = (props, logger) => {
    return props.platform === "VISTA" && hasVistaChatPropValidationError(props, logger);
};
const getcorrelationId = () => {
    return sessionStorage.getItem('correlationId') || undefined;
};
const getRoutingURL = (reponse, platform) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    for (const ls of reponse.nodewhitelist.metadata) {
        //eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        if (ls.platform.includes(platform)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
            return ls.url;
        }
    }
};
const isNotLoaded = (isProd, loadedState) => {
    return !isProd && !loadedState;
};
const IVAChat = (props) => {
    const [loadedState, setLoadedState] = useState(false);
    const [hostName, sethostName] = useState(props.apiHostName);
    const logger = ConsoleLogger.getInstance(defaultLogLevel);
    const isProd = isProdEnv(props.apiHostName);
    useEffect(() => {
        if (isNotLoaded(isProd, loadedState)) {
            fetch(getFileURL(props.apiHostName))
                .then((response) => response.json())
                .then((out) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const url = getRoutingURL(out, props.platform);
                sethostName(url);
                setLoadedState(true);
            })
                .catch(() => {
                sethostName(props.apiHostName);
                setLoadedState(true);
            });
        }
        else if (isProd) {
            setLoadedState(true);
        }
    }, []);
    if (hasInvalidProps(props, logger)) {
        return null;
    }
    if (loadedState) {
        /**
      * Update function updateAppConfigState on adding new Node module specific props
      */
        const appConfig = Object.assign(Object.assign({}, defaultConfig), { main: {
                apiHostName: hostName,
                appAccessKey: props.appAccessKey,
                isLoggedIn: props.isLoggedIn,
                showIvaChatIcon: props.showIvaChatIcon,
                clientSessionId: props.clientSessionId,
                userMetadata: props.userMetadata,
                platform: props.platform,
                interactionId: getcorrelationId(),
            }, get webUrl() { return `https://${hostName}/Alme`; } });
        appConfig.isMobile = isMobileDevice();
        if (appConfig.isMobile) {
            appConfig.channel = "MobileWeb";
        }
        return (React.createElement(ErrorBoundary, { appConfig: appConfig },
            React.createElement(App, { isOpen: props.isOpen, onMinimize: props.onMinimize, onClose: props.onClose, appConfig: appConfig })));
    }
    else {
        return null;
    }
};
export default IVAChat;
